// import './arib-subtitle.css';
// import './arib-subtitle-colors.css';
import './arib-vtt-styles';
import DrcsDecoder from './drcs-decoder.js';
const aribVttStyles = require('./arib-vtt-styles');

const styles = {
  swf: {
    swf7: {w: 960, h:540},
    swf9: {w: 720, h:480}
  }
};
const tags = {
  textType : ['ssz', 'msz', 'nsz'],
  color : ['bkf', 'rdf', 'grf', 'ylf', 'blf', 'mgf', 'cnf', 'whf']
};
const types = {
  swfType: {
    swf7: 7,
    swf9: 9
  },
  colType: {
    palette: 2,     // パレット
    text: 4,        // 前景色
    bg: 5,          // 背景色
    textMiddle: 6,  // 前中間色 (未実装)
    bgMiddle: 7     // 背中間色 (未実装)
  },
  orn: {
    stroke: 1
  }
};
// From https://github.com/darkskyapp/string-hash
const hash = function(text) {
    let hash = 5381;
    let i = text.length;
    while (i) {
        hash = (hash * 33) ^ text.charCodeAt(--i);
    }
    return (hash >>> 0).toString();
};

class AribSubtitleXmlParser {

  // frag = {start: 1.2/* secs */, duration: 5.2/* secs */};
  // media = video Element
  constructor(frag, payload, media, initPTS, adjustWithPTS, debug) {
    this.frag = frag;
    this.payload = payload;
    this.media = media;
    this.initPTS = initPTS;
    this.adjustWithPTS = adjustWithPTS;
    this.cues = [];
    this.styles = [];
    this.debug = debug;

    //default
    this.plain = styles.swf.swf7; // swf. 字幕プレーン
    this.display = {}; // sdf, sdp, acps 表示領域
    this.palette = 0; // 0-7
    this.textColorClass = 'whf-p0';
    this.bgColorClass = undefined;
    this.ornClass = undefined;
    this.rcsClass = undefined;
    this.textSetting = {type:'nsz', w:36,h:36, vs:24, hs: 4};//typeはテキスト設定時のtype
    this.textType = 'nsz';
    this.text = '';
    this.plainText = '';
    this.position = undefined;
    //this.drcs = [];
    this.fontSizeInit  = false;
  }

  // callback = (err, cues) => {};
  parse(callback) {
    console.log('parse');
    const parser = new DOMParser();
    const doc = parser.parseFromString(this.payload, "application/xml");
    const dataGroup = doc.firstElementChild;
    //const pdt = dataGroup.getAttribute('LOCAL'); // program date time
    const pts = parseInt(dataGroup.getAttribute('PTS'), 10); // pts
    // Calculate subtitle offset in milliseconds.
    // If sync PTS is less than zero, we have a 33-bit wraparound, which is fixed by adding 2^33 = 8589934592.
    let initPTS = this.initPTS < 0 ? this.initPTS + 8589934592 : this.initPTS;
    this.startTime = this.adjustWithPTS? (pts - initPTS)/90000 : this.frag.start;
    console.log('pts', 'subtitle:' + pts + ' videoInitPts:' +initPTS);
    this.endTime = this.startTime + this.frag.duration;

    const captionDatas = dataGroup.getElementsByTagName('caption_data');
    if (!captionDatas || captionDatas.length === 0) {
      console.log('parse error: captionDatas is empty');
      callback(undefined, this.cues);
      return;
    }
    const dataUnits = captionDatas[0].getElementsByTagName('data_unit');
    if (!dataUnits || dataUnits.length === 0) {
      console.log('parse error: dataUnits is empty');
      callback(undefined, this.cues);
      return;
    }
    this._parseDataUnits(dataUnits);
    if (this.cues.length === 0) {
      // indefinite対応、空のキューを設定する
      const cue = window.VTTCue?
        new window.VTTCue(this.startTime, this.endTime, '') :
        new window.TextTrackCue(this.startTime, this.endTime, '');
      this.cues.push(cue);
    }

    callback(undefined, this.cues);
  }

  _parseDataUnits(dataUnits) {
    Array.from(dataUnits).forEach(dataUnit => {
      const parameter = parseInt(dataUnit.getAttribute('parameter'), 16);
      if (parameter === 0x20) {
        this._parseCaption(dataUnit);
      }
      else if (parameter === 0x30) {
        this._parseDrcs(dataUnit);
      }
    });
  }

  _parseDrcs(dataUnit) {
    const drcsDataStructure = dataUnit.firstElementChild;
    if (!drcsDataStructure) {
      return;
    }
    const drcsCodeStructures = drcsDataStructure.children;
    if (drcsCodeStructures.length === 0) {
      return;
    }
    Array.from(drcsCodeStructures).forEach(drcsCodeStructure => {
      const characterCode = drcsCodeStructure.getAttribute('CharacterCode');
      const pattern = drcsCodeStructure.firstElementChild;
      if (!pattern) {
        return;
      }
      const width = pattern.getAttribute('width');
      const height = pattern.getAttribute('height');
      const depth = pattern.getAttribute('depth');
      const type = pattern.getAttribute('type');
      const className = 'drcs-' + characterCode;
      this.styles[className] =
        ':root {\n'
        + '  --' +className +'-width: ' +width +';\n'
        + '  --' +className +'-height: ' +height +';\n'
        + '  --' +className +'-depth: ' +depth +';\n'
        + '  --' +className +'-pattern: ' +pattern.textContent +';\n'
        // TR-B14, TR-B15 より DRCS は定義時のサイズで呼び出されるので 1通り だけ記載する
        // TODO: DRCS定義時にサイズを判定しないと適切な大きさや余白を設定できない(現時点は全て NSZ)
        + '  --' +className +'-horizontal-margin: ' +(this.textSetting.hs * 100 / (this.plain.w * 2)) +'vw;\n'
        + '  --' +className +'-fontSize: ' +(this.textSetting.w * 100 / this.plain.w) +'vw;\n'
        +'}';
      // for debug
      if (this.debug) {
        setTimeout(() => {
          const canvas = DrcsDecoder.draw(width, height, depth, type, pattern.textContent, '#fff');
          const drcsRoot = document.getElementById("drcs");
          drcsRoot.appendChild(canvas);
          canvas.addEventListener('click', () => {this.media.currentTime = this.startTime;}, false);
          canvas.style.cursor = 'pointer';
        }, 1000);
      }
    });
  }

  _parseCaption(dataUnit) {

    // createTextTrackCue
    Array.from(dataUnit.children).forEach(el => {
      const tagName = el.tagName.toLowerCase();
      // SWF
      if (tagName === 'swf') {
        this._parseSwf(el);
      }
      // SDF
      else if (tagName === 'sdf') {
        this.display.w = parseInt(el.getAttribute('P1'), 10);
        this.display.h = parseInt(el.getAttribute('P2'), 10);
      }
      // SDP
      else if (tagName === 'sdp') {
        this.display.x = parseInt(el.getAttribute('P1'), 10);
        this.display.y = parseInt(el.getAttribute('P2'), 10);
      }
      // ACPS
      else if (tagName === 'acps') {
        this._parseAcps(el);
      }
      // SSM
      else if (tagName === 'ssm') {
        this.textSetting.w = parseInt(el.getAttribute('P1'), 10);
        this.textSetting.h = parseInt(el.getAttribute('P2'), 10);
      }
      // SHS
      else if (tagName === 'shs') {
        this.textSetting.hs = parseInt(el.getAttribute('P1'), 10); // 字間隔
      }
      // SVS
      else if (tagName === 'svs') {
        this.textSetting.vs = parseInt(el.getAttribute('P1'), 10); // 行間隔
      }
      // APS
      else if (tagName === 'aps') {
        this._parseAps(el);
      }
      // PAPF
      else if (tagName === 'papf') {
        this._parsePapf(el);
      }
      // BKF, RDF, GRF, YLF, BLF, MGF, CNF, WHF
      else if (tags.color.includes(tagName)) {
        this.textColorClass = tagName + '-p' +this.palette;
      }
      // SSZ,MSZ,NSZ
      else if (tags.textType.includes(tagName)) {
        //this.textSetting.type = tagName;
        this.textType = tagName;
      }
      else if (tagName === 'col') {
        this._parseCol(el);
      }
      // ORN
      else if (tagName === 'orn') {
        //
        const p1 = parseInt(el.getAttribute('P1'), 10);
        //const p2 = el.getAttribute('P2');
        //const color = p2 !== undefined? parseInt(p2) : 1;
        if (p1 === types.orn.stroke) {
          this.ornClass = 'orn-stroke';
        }
      }
      // RCS
      else if (tagName === 'rcs') {
        const p1 = parseInt(el.getAttribute('P1'), 10);
        const colorIndex = p1 & 0x0f;
        this.rcsClass = 'rcs-p' +this.palette +'-' +colorIndex;
      }
      // HLC
      else if (tagName === 'hlc') {
        const p1 = parseInt(el.getAttribute('P1'), 16);
        console.log('hlc=' +p1);
        const hlcOption = p1 & 0x0f;
        this.hlcClass = 'hlc-' + hlcOption;
      }
      // STL
      else if (tagName === 'stl') {
        console.log('stl=');
      }
      // DRCS
      else if (tagName === 'drcs') {
        const characterCode = el.getAttribute('CharacterCode');
        // placeholder
        this.text += this._createDrcsPlaceHolder(characterCode);
      }
      // TEXT
      else if (tagName === 'text') {
        this._parseText(el);
      }
    });
    if (this.text && this.position) {
      this._addCue();
      console.log('_addCue');
    }
  }

  _parseSwf(el) {
    const p1 = parseInt(el.getAttribute('P1'), 10);
    if (p1 === types.swf9) {
      this.plain = styles.swf.swf9;
    }
    else {
      this.plain = styles.swf.swf7;
    }
  }

  _parseAcps(el) {
    console.log('acps');
    const x = parseInt(el.getAttribute('P1'), 10);
    const y = parseInt(el.getAttribute('P2'), 10);
    if (this.position) {
      // ACPSが指定されてる場合は、TextTrackCueを都度生成する
      this._addCue();
    }
    const rowHeight = this.textSetting.h + this.textSetting.vs;
    const kukaku = this._getKukaku('nsz');
    this.position = {
      x: x / this.plain.w * 100,
      y: (y - rowHeight) / this.plain.h * 100,
      kukaku: { // nsz基準で現在位置を保持しておく
        x: (x-this.display.x)/kukaku.w,
        y: (y-this.display.y)/kukaku.h
      },
      textType: this.textType,
      textSetting: this.textSetting,
      aps: false
    };
  }

  _parseAps(el) {
    if (!this.textType) {
      this.textType = 'nsz';
    }
    const p1 = parseInt(el.getAttribute('P1'), 16) & 0x3f;
    const p2 = parseInt(el.getAttribute('P2'), 16) & 0x3f;
    const dotPosition = this._getDotPosition(p1, p2);
    if (this.position) {
      // APSが複数指定されてる場合は、TextTrackCueを都度生成する
      this._addCue();
    }
    this.position = {
      x: (this.display.x + dotPosition.x) / this.plain.w * 100,
      y: (this.display.y + dotPosition.y) / this.plain.h * 100,
      kukaku: { // nsz基準で現在位置を保持しておく
        x: this.textType === 'nsz'? p2: p2/2,
        y: this.textType === 'ssz'? p1/2: p1
      },
      textType: this.textType,
      textSetting: this.textSetting,
      aps: true
    };
    //console.log('position', this.position);
  }

  _getDotPosition(p1, p2) {
    const kukaku = this._getKukaku(this.textType);
    return {
      x : p2 * kukaku.w,
      y : p1 * kukaku.h
    }
  }

  _getDotPositionX(kukakuCount, textType) {
    return kukakuCount * this._getKukaku(textType).w;
  }

  _getDotPositionY(kukakuCount, textType) {
    return kukakuCount * this._getKukaku(textType).h;
  }

  _getKukaku(textType) {
    if (textType === 'ssz') {
      return {
        w: (this.textSetting.w + this.textSetting.hs)/2,
        h: (this.textSetting.h + this.textSetting.vs)/2
      };
    }
    if (textType === 'msz') {
      return {
        w: (this.textSetting.w + this.textSetting.hs)/2,
        h: this.textSetting.h + this.textSetting.vs
      };
    }
    return {
      w: (this.textSetting.w + this.textSetting.hs),
      h: this.textSetting.h + this.textSetting.vs
    };
  }

  _parsePapf(el) {
    const beforeText = this.plainText;//for log
    if (this.position) {
      this._addCue();
    }
    const p1 = parseInt(el.getAttribute('P1'), 16) & 0x3f;
    const kukaku = this._getKukaku('nsz');
    const nszPapf = this.textType === 'nsz'? p1: p1/2;
    //const maxKukakuCount = Math.floor(this.display.w / kukaku.w);//切り捨て
    const maxKukakuCount = this.display.w / kukaku.w; // msz、nszが混在するので切り捨てない
    var kukakuCount = this.position.kukaku.x + nszPapf;
    console.log('papf', this.position.kukaku.x +'+' +nszPapf +' beforeText=' +beforeText);
    //画面内に収まってる場合
    // テキストの一部だけはみ出る場合は未対応
    if (maxKukakuCount > kukakuCount) {
      // 折り返さない
      this.position.x = (this.display.x + this._getDotPositionX(kukakuCount, 'nsz')) / this.plain.w * 100;
      this.position.kukaku.x = kukakuCount;
      return;
    }
    // 改行、2行以上の改行は未対応
    this.position.y += this._getDotPositionY(1, this.textSetting.textType) / this.plain.h * 100;
    kukakuCount %= maxKukakuCount;
    this.position.x = (this.display.x + this._getDotPositionX(kukakuCount, 'nsz')) / this.plain.w * 100;
    this.position.kukaku.x = kukakuCount;
    this.position.isPapf = true;
  }

  _parseCol(el) {
    const p1 = parseInt(el.getAttribute('P1'), 16);
    const colType = p1 >> 4;
    const val = p1 & 0x0f;
    //前景色
    if (colType === types.colType.text) {
      this.textColorClass = 'text-p' +this.palette +'-' +val;
    }
    //背景色
    else if (colType === types.colType.bg) {
      this.bgColorClass = 'bg-p' +this.palette +'-' +val;
    }
    else if (colType === types.colType.palette) {
      this.palette = parseInt(el.getAttribute('P2'), 16) & 0x0f;
    }
  }

  // oncuechange内で動的にcanvasに置き換える
  _createDrcsPlaceHolder(characterCode) {
    this.textSetting.type = this.textType;
    var classNames = [];
    classNames.push('.drcs-' +characterCode);
    // SSZ,MSZ,NSZ
    if (this.textSetting.type) {
      classNames.push(this.textSetting.type);
    }
    if (this.textColorClass) {
      classNames.push(this.textColorClass);
    }
    if (this.bgColorClass) {
      classNames.push(this.bgColorClass);
    }
    if (this.ornClass) {
      classNames.push(this.ornClass);
    }
    if (this.hlcClass) {
      classNames.push(this.hlcClass);
    }
    const className = '.' + classNames.join('.');
    this._addStyles(classNames);
    // PAPF用にDRCS分ずらした位置を保存
    if (this.position.kukaku !== undefined) {
      this.position.kukaku.x += this.textSetting.type === 'nsz'? 1 : 0.5;
    }
    return '<c' + className + '></c>';
  }

  _parseText(el) {
    if (!el.textContent || el.textContent.length === 0) return;
    this.textSetting.type = this.textType;
    var plainText = this._normalize(el.textContent, this.textSetting.type);

    // 位置指定なしに文字が来た場合 APS 0 0 をした扱いにする
    if (!this.position) {
      const dotPosition = this._getDotPosition(0, 0);
      this.position = {
        x: (this.display.x + dotPosition.x) / this.plain.w * 100,
        y: (this.display.y + dotPosition.y) / this.plain.h * 100,
        kukaku: { // nsz基準で現在位置を保持しておく
          x: 0, y: 0,
        },
        textType: this.textType,
        textSetting: this.textSetting,
        aps: true
      };
    }

    // APSかつ行末の場合は改行（1行進めて、先頭に移動）する
    if (!this.position.isPapf) {
      const maxKukakuCount = this.display.w / this._getKukaku('nsz').w;
      const kukakuCount =
        this.position.kukaku.x +
        (this.textSetting.type === 'nsz'? plainText.length : plainText.length/2);
      if (maxKukakuCount < kukakuCount) {
        if (maxKukakuCount === this.position.kukaku.x) {
          this._addCue();
        }
        else {
          const textLength =
            plainText.length -
            (this.textSetting.type === 'nsz'? (kukakuCount-maxKukakuCount) : (kukakuCount-maxKukakuCount)*2);
          this._addText(plainText.substr(0, textLength));
          this._addCue();
          plainText = plainText.slice(textLength);
        }
        this.position.kukaku.x = 0; // 先頭へ
        this.position.kukaku.y++; // 1行進む
        this.position.y += this._getDotPositionY(1, this.textSetting.type) / this.plain.h * 100; // 1行進む
        this.position.x = this.display.x / this.plain.w * 100; // 先頭へ
        this.position.textType = 'nsz';
      }
    }
    this._addText(plainText);
  }

  _addText(plainText) {
    var classNames = [];
    // SSZ,MSZ,NSZ
    if (this.textSetting.type) {
      classNames.push(this.textSetting.type);
    }
    if (this.textColorClass) {
      classNames.push(this.textColorClass);
    }
    if (this.bgColorClass) {
      classNames.push(this.bgColorClass);
    }
    if (this.ornClass) {
      classNames.push(this.ornClass);
    }
    if (this.hlcClass) {
      classNames.push(this.hlcClass);
    }
    const className = '.' + classNames.join('.');
    this._addStyles(classNames);

    // 次の文字の開始位置を記憶しておく. PAPF制御に利用.
    if (this.position.kukaku !== undefined) {
      this.position.kukaku.x += this.textSetting.type === 'nsz'? plainText.length : plainText.length/2;
    }
    this.plainText += plainText;
    this.text += '<c' + className + '>' + plainText + '</c>';
  }

  _addStyles(classNames) {
    const colorPfxs = ['text', 'bg', 'hlc'].concat(tags.color);
    classNames.forEach(className => {
      const pfx = className.split('-')[0];
      if (colorPfxs.includes(pfx)) {
        this._addColorStyle(className, pfx);
        return;
      }
      this.styles[className] = aribVttStyles[className];
    });
  }

  //'bkf', 'rdf', 'grf', 'ylf', 'blf', 'mgf', 'cnf', 'whf'
  //'text-', 'bg-'
  _addColorStyle(className, pfx) {
    //
    if (tags.color.includes(pfx)) {
      this.styles[className] = '::cue(.' +className +') {\n  color: ' +this._getColorWithClassName(className) +';\n}';
      return;
    }
    if (pfx === 'text') {
      const colorIdx = className.substr(5);
      this.styles[className] = '::cue(.' +className + ') {\n  color: ' +this._getColorWithIndex(colorIdx) +';\n}';
      return;
    }
    if (pfx === 'bg') {
      const colorIdx = className.substr(3);
      this.styles[className] = '::cue(.' +className + ') {\n  background-color: ' +this._getColorWithIndex(colorIdx) +';\n}';
      return;
    }
    if (pfx === 'hlc') {
      this._addHlcStyle(className);
    }
  }

  _getColorWithClassName(className) {
    return aribVttStyles.colors[className];
  }

  _getColorWithIndex(colorIdx) {
    return aribVttStyles.colors[colorIdx];
  }

  // 'hlc-'
  _addHlcStyle(className) {
    // 文字色をボーダ色に指定する
    const colorClassPfx = this.textColorClass.split('-')[0];
    var color =
      tags.color.includes(colorClassPfx)?
      this._getColorWithClassName(this.textColorClass) :
      this._getColorWithColorIndex(this.textColorClass.substr(5));

    var style = '::cue(.' +className + ') {';
    const hlcOption = className.substr(4);
    if ((hlcOption & 0b1) === 0b1) {
      style += '  border-bottom: 1px solid ' + color + ';\n';
    }
    if ((hlcOption & 0b10) === 0b10) {
      style += '  border-right: 1px solid ' + color + ';\n';
    }
    if ((hlcOption & 0b100) === 0b100) {
      style += '  border-top: 1px solid ' + color + ';\n';
    }
    if ((hlcOption & 0b1000) === 0b1000) {
      style += '  border-left: 1px solid ' +color + ';\n';
    }
    style += '}';
    this.styles[className] = style;
  }

  _addCue() {
    const cueId = this._generateUuid();
    this._setCueStyle(this.position.textSetting);
    const textTrackCue = this._createTextCue(cueId, this.text, this.position);
    this.cues.push(textTrackCue);
    textTrackCue.url = this.frag.url; // for debug
    this.text = '';
    this.plainText = '';
  }

  _setCueStyle(textSetting) {
    if (this.fontSizeInit) return;
    const fontSize = textSetting.w / this.plain.w * 100; // %
    const lineHeight = (textSetting.h + textSetting.vs) / textSetting.w; // em
    //const letterSpacing = textSetting.hs / 2 / textSetting.w; // em
    const letterSpacing = textSetting.hs / textSetting.w; // em
    // this.fontSize = fontSize; // vw
    this.lineHeight = lineHeight; // em
    this.letterSpacing = letterSpacing; // em
    var style =
      //'video::-webkit-media-text-track-container, ::cue {\n'
      '::cue {\n'
        + '  font-size: ' +fontSize +'vw;\n'
        + '  line-height: ' +lineHeight +'em;\n'
        + '  letter-spacing: ' +letterSpacing +'em;\n'
        + '  display: inline-block;}';
    this.styles['cue'] = style;
    this.fontSizeInit = true;
  }

  _normalize(text, textType) {
    // これらは TMD のXML出力のワークアラウンド
    return text
        .replace(/ $/, '')  // 文字列の終端に半角スペースが入ってる場合があるので削除する。
        .replace('−', '－'); // U+2212 (MINUS-SIGN) を U+FF0D (FULLWIDTH HYPHEN-MINUS)に
  }

  _createTextCue(cueId, text, position) {
    const textTrackCue = window.VTTCue?
      new window.VTTCue(this.startTime, this.endTime, text) :
      new window.TextTrackCue(this.startTime, this.endTime, text);
    textTrackCue.id = cueId;
    textTrackCue.align = 'start';
    textTrackCue.positionAlign = 'line-left'; // Chrome66から有効、Chrome67から無効
    textTrackCue.position = position.x;
    textTrackCue.line = this._adjustY(position);
    textTrackCue.snapToLines = false;
    textTrackCue.vertical = '';
    textTrackCue.style = Object.values(this.styles).join('\n');
    // TODO styleだけで対応する
    // textTrackCue.fontSize = this.fontSize;
    textTrackCue.lineHeight = this.lineHeight;
    textTrackCue.letterSpacing = this.letterSpacing;
    textTrackCue.onenter = (e) => {
  //    console.log('onenter', e.currentTarget.text);
    };
    return textTrackCue;
  }

  // APS指定時のtextTypeとTEXT指定時のtextTypeが異なる場合に微調整
  _adjustY(position) {
    // // apsのtextTypeとtextのtextTypeが同じ場合
    if (position && position.aps && !position.isPapf) {
      // sszでaps指定してテキストもssz
      if (position.textType === 'ssz') {
        if (this.textSetting.type === 'ssz') {
          return position.y - this._getDotPositionY(1, 'ssz') / this.plain.h * 100;
        }
        position.y -= this._getDotPositionY(1, 'ssz') / this.plain.h * 100;
      }
    }
    return position.y;
  }

  _generateUuid() {
    return hash(this.startTime.toString()) + hash(this.endTime.toString()) + this.cues.length;
    // return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    //   (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    // )
  };

};

export default AribSubtitleXmlParser;



// WEBPACK FOOTER //
// ./src/hlsjs/arib-subtitle-xml-parser.js